import './ContainerInput.css';

const ContainerInput = ({ children }) => <div className="container-password-input">{children}</div>;

export default ContainerInput;
